import React from 'react';
import FormHeader from '../../../components/FormHeader'

const buttonName = 'CREATE NEW PRE-ENERGIZATION FORM';

const PreEFormHeader =({ ...props }) => (
    <FormHeader {...props} buttonName={buttonName} />
);

export default PreEFormHeader;